/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserAudit} from '../models/UserAudit';

export interface GetUsersAudit$Request {
    requestBody: Array<number>;
}

export interface GetUsersAudit$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUsersAuditRequest = createAction<PayloadData<void, GetUsersAudit$Request>>('AUDIT_CONTROLLER__GET_USERS_AUDIT__REQUEST');
export const getUsersAuditSuccess = createAction<PayloadData<{ [key: string]: UserAudit; }, GetUsersAudit$Request>>('AUDIT_CONTROLLER__GET_USERS_AUDIT__SUCCESS');
export const getUsersAuditFailure = createAction<PayloadData<Error, GetUsersAudit$Request, true>>('AUDIT_CONTROLLER__GET_USERS_AUDIT__FAILURE');

export const getUsersAuditActions = [
    getUsersAuditRequest,
    getUsersAuditSuccess,
    getUsersAuditFailure
] as const;

/**
 * @param {Array<number>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUsersAudit = (meta: GetUsersAudit$Request, config?: GetUsersAudit$Config) => {
    return {
        CALL_API: {
            types: getUsersAuditActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/audit`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

